<template>
  <div class="about">
    <br><h3>Discover the Cosmos!</h3>
    <br><p>Each day a different image or photograph of our fascinating universe is featured, along with a brief explanation written by a professional astronomer.</p>
    <br><hr>
    <br><p>This is a Vue.js application developed by thigoap.<br>
    You can find the source code <a href="https://github.com/thigoap/NASAapod.git">here</a>.</p>
  </div>
</template>

<script>
export default {
  name: 'About'
}
</script>

<style scoped>
</style>
